import { fetchJSON } from '@bonnet/core/fetch';
import { logger } from '@bonnet/core/logger';
import _get from 'lodash/get';
import cache from '../cache';
import constants from '../constants';
const {
  KBB_DMA_CODES
} = constants;
// caching time in milisecond (14 days)
const CACHING_TIME = 1209600000;
const options = {
  circuitBreaker: {
    id: 'kbbDmaCodes',
    timeout: 5000,
    resetTimeout: 60000,
    fallback: {}
  }
};
export default async function getKbbDmaCode(zip, assetPrefix) {
  let response = '';
  try {
    // validate zip exists or is 5 digits
    if (!zip || zip === '' || zip && !/^\d{5}$/.test(zip)) {
      throw Error(`${zip} argument is missing or invalid`);
    }
    let success = false;

    // retrieve kbbDmaCode from cache
    const kbbDmaCodes = await cache.get(KBB_DMA_CODES);
    let kbbDmaCode = _get(kbbDmaCodes, zip);

    // return cached kbbDmaCode data if we have it
    if (kbbDmaCode) {
      success = true;
    } else {
      // If kbbDmaCode are not available from memory cache then we need to fetch it from the reference proxy API
      const kbbDmaCodeResponse = await fetchJSON(`/${assetPrefix}/${KBB_DMA_CODES}/${zip}`, options);
      if (process.env.NODE_ENV === 'development') {
        logger.log('[@atc/bonnet-reference/getKbbDmaCode] kbb dma string :: ');
        logger.log(kbbDmaCodeResponse);
      }
      kbbDmaCode = _get(kbbDmaCodeResponse, 'directMarketingArea.code');
      if (kbbDmaCode) {
        success = true;
        // update the kbbDmaCode cache with this zipcode's kbbDmaCode data
        cache.put(KBB_DMA_CODES, {
          ...kbbDmaCodes,
          [zip]: kbbDmaCode
        }, {
          ttl: CACHING_TIME
        });
      }
    }

    // throw error if the fetch returns unsuccessfully
    if (!success) {
      throw Error(`can not get KBB dma code for ${zip}`);
    }

    // set the payload and success status on the response
    response = kbbDmaCode;
  } catch ({
    message
  }) {
    if (process.env.NODE_ENV === 'development') {
      logger.log(`[@atc/bonnet-reference/getKbbDmaCode] ${message}`);
    }
  }
  return response;
}